import { createContext } from 'react';

import type {
  InventoryCardContextType,
  Nullable,
} from '@app/providers/InventoryCardProvider/InventoryCardProvider.types';

export const InventoryCardContext =
  createContext<Nullable<InventoryCardContextType>>(null);
